import { render, staticRenderFns } from "./AdminActionEdit.vue?vue&type=template&id=3048caa1&"
import script from "./AdminActionEdit.vue?vue&type=script&lang=js&"
export * from "./AdminActionEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminActionEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports